import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

interface ContextoRaiz {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<ContextoRaiz>()({
  component: () => <Outlet />,
});
